 // src/components/ProtectedRoute.js
 import { useContext, useEffect, useState } from "react";
 import { Navigate, useLocation } from "react-router-dom";
 import { AuthContext } from "../context/AuthContext";
 
 export default function ProtectedRoute({ children, requiredPermission }) {
   const { token, userPermissions, loading, setRedirectAfterLogin } =
     useContext(AuthContext);
   const location = useLocation();
   const [shouldRedirect, setShouldRedirect] = useState(false);
 
   // ✅ استدعاء hook في مستوى ثابت
   useEffect(() => {
     // الشرط داخل الـ effect نفسه
     if (!token) {
       setRedirectAfterLogin(location.pathname);
       setShouldRedirect(true);
     }
   }, [token, location.pathname, setRedirectAfterLogin]);
 
   if (loading) {
     return (
       <div style={{ textAlign: "center", marginTop: 50 }}>
         Loading permissions...
       </div>
     );
   }
 
   if (shouldRedirect) {
     return <Navigate to="/login" replace />;
   }
 
   if (token && (!userPermissions || userPermissions.length === 0)) {
     return (
       <div style={{ textAlign: "center", marginTop: 50 }}>
         Checking access...
       </div>
     );
   }
 
   if (requiredPermission && !userPermissions.includes(requiredPermission)) {
     return <Navigate to="/denied" replace />;
   }
 
   return children;
 }
 